export default "9161724700206ea9.svg"